/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TransferDom from "vux/src/directives/transfer-dom/index.js";
export default {
  props: {
    isShop: {
      type: Boolean,
      "default": false
    },
    orderList: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    all: Boolean,
    num: [Number, String],
    btnStr: {
      type: String,
      "default": '提交订单'
    },
    disabled: Boolean
  },
  directives: {
    TransferDom: TransferDom
  },
  components: {
    TransferDom: TransferDom
  },
  data: function data() {
    return {
      checked: false,
      numNow: 0
    };
  },
  computed: {},
  created: function created() {
    if (this.all) {
      this.checked = this.all;
    }

    if (this.num) {
      this.numNow = this.num;
    }
  },
  watch: {
    all: function all(val) {
      this.checked = val;
    },
    num: function num(val) {
      this.numNow = val;
    }
  },
  methods: {
    radioAll: function radioAll() {
      this.checked = !this.checked;
      this.$emit('radioHandle', this.checked);
    },
    handleDone: function handleDone() {
      if (this.disabled) {
        return;
      }

      this.$emit('orderHandle');
    }
  }
};